import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function UrgencySection() {
  return <section className="py-8 px-4 bg-burgundy-900 text-cream-50 text-center relative overflow-hidden" data-id="element-202">
      {/* Subtle background pattern/gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-burgundy-800 to-burgundy-900" data-id="element-203"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-4xl bg-dusty-rose-900/20 rounded-full filter blur-3xl" data-id="element-204"></div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-205">
        <FadeIn data-id="element-206">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 flex items-center justify-center gap-3 text-gold-300" data-id="element-207">
            <span className="text-3xl" data-id="element-208">⚠️</span> Este precio no va a durar
          </h2>

          <div className="space-y-3 text-lg md:text-xl text-cream-100" data-id="element-209">
            <p data-id="element-210">El precio de $11 USD es especial de lanzamiento.</p>
            <p data-id="element-211">
              Cuando este lanzamiento cierre el precio sube y los bonus
              desaparecen.
            </p>
            <p className="font-bold text-white" data-id="element-212">
              No hay fecha garantizada para que vuelva a este valor.
            </p>
          </div>

          <motion.a href="https://pay.hotmart.com/S104936734A?checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center justify-center gap-2 bg-gold-300 text-burgundy-900 font-bold py-2.5 px-12 rounded-full shadow-xl hover:shadow-2xl hover:bg-gold-400 transition-all w-full max-w-xl border border-gold-400/50 mt-8 text-center" data-id="element-213">
            <span className="text-sm md:text-base whitespace-nowrap" data-id="element-214">
              🌟 SÍ QUIERO APROVECHAR LA OFERTA
            </span>
            <span className="text-[9px] font-normal opacity-70 whitespace-nowrap" data-id="element-215">
              · 💱 Pagarás en la moneda de tu país
            </span>
          </motion.a>
        </FadeIn>
      </div>
    </section>;
}